import { useCallback } from 'react';
import { useQueryParam, NumberParam } from 'use-query-params';
export const usePagination = () => {
    const [page, setPage] = useQueryParam('page', NumberParam);
    const currentPage = page || 1;
    const setCurrentPage = useCallback((newPage) => setPage(newPage), [setPage]);
    return [currentPage, setCurrentPage];
};
